import apiFetch from "../../../shared/services/apiClient";
import { createWithPersona } from "./createWithPersona";
import { createFilial } from "./createFilial";

export async function createResidentSequence(formData) {
  // Crear filial (condominio lo inyecta el backend desde request.user)
  const filial = await createFilial({
    idFilial:        formData.filial.idFilial,
    numPlano:        formData.filial.numPlano,
    numFolio:        formData.filial.numFolio,
    tipo_propiedad:  formData.filial.tipoPropiedad,
  });

  const filialId = filial.id;

  // Crear propietario — incluye todos los campos nuevos
  const propietarioRes = await createWithPersona(
    "/api/residents/propietario/",
    {
      cedula:          formData.propietario.cedula,
      nombre:          formData.propietario.nombre          || '',
      apellidos:       formData.propietario.apellidos       || '',
      nombre_sociedad: formData.propietario.nombre_sociedad?.trim() || '',
    },
    {
      filial:            filialId,
      telefono_casa:     formData.propietario.telefono_casa?.trim()    || null,
      telefono_cel:      formData.propietario.telefono_cel?.trim()     || null,
      telefono_trabajo:  formData.propietario.telefono_trabajo?.trim() || null,
      placa_vehiculo:    formData.propietario.placaVehiculo?.trim()    || null,
      notas:             formData.propietario.notas?.trim()            || "",
    },
  );

  if (!propietarioRes.ok) {
    const err = await propietarioRes.json().catch(() => ({}));
    throw new Error('Error al crear propietario: ' + JSON.stringify(err));
  }
  const propietario   = await propietarioRes.json();
  const propietarioId = propietario.id;

  // Email principal
  await apiFetch("/api/residents/emailPropietario/", {
    method: "POST",
    body: JSON.stringify({
      propietario: propietarioId,
      email:       formData.propietario.emailPrincipal,
      principal:   true,
    }),
  });

  // Emails extra
  await Promise.all(
    (formData.propietario.emailExtras || [])
      .filter(item => item.email?.trim())
      .map(item =>
        apiFetch("/api/residents/emailPropietario/", {
          method: "POST",
          body: JSON.stringify({
            propietario: propietarioId,
            email:       item.email.trim(),
            principal:   false,
          }),
        })
      )
  );

  // Copropietarios
  await Promise.all(
    formData.copropietarios.map(item =>
      createWithPersona("/api/residents/copropietario/", {
        cedula:          item.cedula,
        nombre:          item.nombre,
        apellidos:       item.apellidos,
        nombre_sociedad: item.nombre_sociedad?.trim() || "",
      }, {
        filial:           filialId,
        telefono_casa:    item.telefono_casa?.trim()    || null,
        telefono_cel:     item.telefono_cel?.trim()     || null,
        telefono_trabajo: item.telefono_trabajo?.trim() || null,
        placa_vehiculo:   item.placaVehiculo?.trim()    || null,
        notas:            item.notas?.trim()            || "",
      })
    )
  );

  // Autorizados
  await Promise.all(
    formData.autorizados.map(item =>
      createWithPersona("/api/residents/autorizado/", {
        cedula:    item.cedula,
        nombre:    item.nombre,
        apellidos: item.apellidos,
      }, {
        filial:        filialId,
        tipo:          item.relacion,
        placa_vehiculo: item.placaVehiculo?.trim() || null,
      })
    )
  );

  return propietario;
}
